import { render, staticRenderFns } from "./sale-day-book.vue?vue&type=template&id=94fd8946&"
import script from "./sale-day-book.vue?vue&type=script&lang=js&"
export * from "./sale-day-book.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports